import { render, staticRenderFns } from "./Gvnts.vue?vue&type=template&id=37bf637e&scoped=true&"
import script from "./Gvnts.vue?vue&type=script&lang=js&"
export * from "./Gvnts.vue?vue&type=script&lang=js&"
import style0 from "./Gvnts.vue?vue&type=style&index=0&id=37bf637e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf637e",
  null
  
)

export default component.exports